import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState('default');

  useEffect(() => {
    const savedTheme = localStorage.getItem('app_theme') || 'default';
    setCurrentTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const changeTheme = (theme) => {
    setCurrentTheme(theme);
    localStorage.setItem('app_theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
  };

  const resetTheme = () => {
    changeTheme('default');
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, changeTheme, resetTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};